const hasRows = (rows) => Array.isArray(rows) && rows.length > 0;

export function availableF24SubPhases({
  ordinaryRows = [],
  savedOrdinaryRows = [],
  globalOrdinaryRows = [],
  globalSavedOrdinaryRows = [],
  clientGroups = {},
  specialRows = [],
  savedSpecialRows = [],
  bankGroups = [],
} = {}) {
  const clientGroupNames = [
    "custom",
    "custom_pdc",
    "non_custom",
    "non_custom_pdc",
  ];
  const hasOrdinary =
    [
      ordinaryRows,
      savedOrdinaryRows,
      globalOrdinaryRows,
      globalSavedOrdinaryRows,
    ].some(hasRows) ||
    clientGroupNames.some((name) =>
      (clientGroups?.[name] || []).some((group) => hasRows(group?.rows))
    );

  const phases = [];
  if (hasOrdinary) phases.push("A");
  if (hasRows(specialRows) || hasRows(savedSpecialRows)) phases.push("B");
  if (hasRows(bankGroups)) phases.push("C");
  return phases;
}
